// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    convertDateOnlyStringToDate,
    convertDateToDateOnlyString,
} from "@insite/client-framework/Common/Utilities/DateUtilities";
import translate from "@insite/client-framework/Translate";
import DatePicker from "@insite/mobius/DatePicker";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/UpdateDraftParameter";
import { useOrderHistoryState } from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { DatePickerPresentationProps } from "@store/MobiusOverrides/DatePicker/DatePicker";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC } from "react";

export interface OrderHistoryFilterFieldOrderDateRangeProps {}

export interface OrderHistoryFilterFieldOrderDateRangeStyles {
    datePicker?: DatePickerPresentationProps;
    fieldWrapper?: InjectableCss;
}

export const OrderHistoryFilterFieldOrderDateRangeStyles: OrderHistoryFilterFieldOrderDateRangeStyles = {
    fieldWrapper: filterDrawerProps.fieldWrapper,
    datePicker: { labelProps: filterDrawerProps.subLabel },
};

const styles = OrderHistoryFilterFieldOrderDateRangeStyles;

const OrderHistoryFilterFieldOrderDateRange: FC<OrderHistoryFilterFieldOrderDateRangeProps> = () => {
    const dispatch = useAppDispatch();
    const { toDate: draftToDate, fromDate: draftFromDate } = useOrderHistoryState().draftParameter;

    const fromDate = convertDateOnlyStringToDate(draftFromDate);
    const toDate = convertDateOnlyStringToDate(draftToDate);

    return (
        <FilterDrawerSection title={translate("Order Dates")} isAccordion={true}>
            <StyledWrapper {...styles.fieldWrapper} data-test-selector="orderHistory_filterFromDate">
                <DatePicker
                    {...styles.datePicker}
                    label={translate("Order Date From")}
                    selectedDay={fromDate}
                    onDayChange={({ selectedDay }) =>
                        dispatch(updateDraftParameter({ fromDate: convertDateToDateOnlyString(selectedDay) }))
                    }
                    dateTimePickerProps={{
                        maxDate: toDate,
                        ...styles.datePicker?.dateTimePickerProps,
                    }}
                />
            </StyledWrapper>
            <StyledWrapper {...styles.fieldWrapper} data-test-selector="orderHistory_filterToDate">
                <DatePicker
                    {...styles.datePicker}
                    label={translate("Order Date To")}
                    selectedDay={toDate}
                    onDayChange={({ selectedDay }) =>
                        dispatch(updateDraftParameter({ toDate: convertDateToDateOnlyString(selectedDay) }))
                    }
                    dateTimePickerProps={{
                        minDate: fromDate,
                        ...styles.datePicker?.dateTimePickerProps,
                    }}
                />
            </StyledWrapper>
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldOrderDateRange;
